<template>
  <div class="grey lighten-4" bold pm-5 mt-5 justify="center">
    <p class=" pt-4 display-2 font-weight-light primary--text">
      Aktuelles
    </p>

    <v-row justify="center">
      <v-col cols="12" sm="6">
        <Diashow :bilder="aktuelles"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'aktuelles',

    components: {
      Diashow: () => import("@/components/core/Diashow")
    },

    data() {
      return {
        aktuelles: [

           {
            titel: "Besuch der Cliniclowns",
            bild: require('@/assets/Aktuelles/2026-06-09 Cliniclowns Kadlez.jpg'),
            text: "Wir hatten neuerlich Besuch von den Cliniclowns"
          },        
          {
            titel: "Frauenrunde",
            bild: require('@/assets/Aktuelles/2026-08-25 Frauenrunde Huemer Riedl Kaiser Polt.jpg'),
            text: "Seit einigen Monaten kommen zwei ehrenamtliche Mitarbeiterinnen für die Frauenrunde auf Besuch."
          },
          {
            titel: "Attersee Ausfahrt",
            bild: require('@/assets/Aktuelles/Ausflug_2019.jpg'),
            text: "Bei strahlendem Sonnenschein durften die Bewohnerinnen und Bewohner eine Runde auf dem Attersee drehen."
          },
          
          {
            titel: "Knacker grillen",
            bild: require('@/assets/Aktuelles/Knacker_grillen_2019.jpg'),
            text: "Mit musikalischer Unterhaltung wurden die teils selbstgebratenen Knacker verspeist."
          },
          {
            titel: "Maibaum aufstellen",
            bild: require('@/assets/Aktuelles/Mailbaum_2019.jpg'),
            text: "Mit musikalischer Unterstützung wurde der Maibaum von den Gründberglern aufgestellt."
          },
          {
            titel: "Therapierad",
            bild: require('@/assets/Aktuelles/Therapierad.jpg'),
            text: "In jedem Stock befindet sich ein Therapierad, welches von den Bewohnerinnen und Bewohnern eifrig genutzt wird."
          },
          {
            titel: "Oktoberfest",
            bild: require('@/assets/Aktuelles/Oktoberfest_2018.jpg'),
            text: "Gemütliches Zusammensitzen mit Bier und Brezln beim Oktoberfest."
          },
          {
            titel: "Heimausflug",
            bild: require('@/assets/Aktuelles/Ausflug_2018.jpg'),
            text: "Nicht einmal der Regen konnte die gute Laune unserer Bewohnerinnen und Bewohner beeinflussen."
          },
          {
            titel: "Zipfelhaubenball",
            bild: require('@/assets/Aktuelles/Zipfelhaubenball_2018.jpg'),
            text: "Mit bunten Hüten feierten wir den Zipfelhaubenball."
          },
          {
            titel: "Singrunde",
            bild: require('@/assets/Aktuelles/Singrunde_2_2018.jpg'),
            text: "Bei der Singrunde im Erdgeschoß, sind alle eingeladen, kräftig mitzusingen."
          },
        ],
      }
    },
  }
</script>

    